<template>
  <el-row class="row" id="socialEvaluation">
    <el-col class="col">
      <Title2
        btnText="VOLVER"
        :title="'ACTUALIZAR APARTADO DE TRABAJO SOCIAL'"
        :label="label"
        v-on:before-submit="volver"
        :createdAt="createdAt"
      />
      <div class="form">
        <el-container>
          <el-main>
            <div class="steps-social">
              <el-steps :active="active" finish-status="success" align-center>
                <el-step title="Sección 1" description="Datos generales"/>
                <el-step title="Sección 2" description="Estructura familiar"/>
                <el-step title="Sección 3" description="Egresos"/>
                <el-step title="Sección 4" description="Cualitativo"/>
              </el-steps>
            </div>
            <div class="component-render">
              <div class="content">
                <generalData
                  v-if="active == 0"
                  :idAppointment="appointmentId"
                />
                <esfamily
                  v-if="active == 1"
                  @total-income="getContribution"
                />
                <egresos
                  v-if="active == 2"
                  :incomeTotal="incomeTotal"
                  :idAppointment="appointmentId"
                  :recreate="recreate"
                />
                <cualitativos
                  v-if="active == 3"
                  :idAppointment="appointmentId"
                />
                <printSocial v-if="active == 4"/>
              </div>
            </div>
            <div
              class="button-container-social"
            >
              <el-button
                v-if="active != 0"
                type="primary"
                @click="previus"
                size="mini"
                icon="el-icon-arrow-left"
                style="background-color: #6a41bdca;"

              >
                Anterior
              </el-button>
              <el-button
                v-if="active != 4"
                type="primary"
                @click="next"
                size="mini"
                icon="el-icon-arrow-right"
                style="background-color: #6a41bdca;"
              >
                Siguiente
              </el-button>
            </div>
            <div class="fotter-section" />
          </el-main>
        </el-container>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import generalData from '../../../components/social/datosGenerales';
import esfamily from '../../../components/social/estructuraFamiliar';
import egresos from '../../../components/social/egresos';
import cualitativos from '../../../components/social/cualitativo';
import printSocial from '../../../components/social/printSocial';

import Title2 from '../../../components/Title2';

export default {
  data() {
    return {
      incomeTotal: 0,
      appointmentId: '',
      patientId: '',
      label: 'Por favor llene los datos requeridos para completar la Evaluación',
      createdAt: '',
      active: 0,
      recreate: false,
    };
  },
  components: {
    generalData,
    esfamily,
    egresos,
    cualitativos,
    printSocial,
    Title2,
  },
  methods: {
    getContribution(e) {
      this.incomeTotal = e;
    },
    async next() {
      this.recreate = !this.recreate;
      if (this.active++ > 3) this.active = 0;
    },
    previus() {
      this.active -= 1;
    },
    async volver() {
      setTimeout(() => { this.$router.replace('/'); });
    },
    async getAppointmentsSocial() {
      try {
        const response = await this.axios.get(`patient/social/getAppointmentSocial/${this.patientId}`);
        if (response.data) {
          this.appointmentId = response.data[0].id;
        } else {
          this.$notify({
            type: 'warning',
            title: 'Sin Datos',
            message: 'Primera Evaluación',
          });
        }
      } catch (error) {
        // this.$errorNotify(error);
      }
    },
  },
  async created() {
    this.patientId = this.$route.params.id;
    await this.getAppointmentsSocial();
  },
};
</script>

<style>
.component-render {
  display: flex;
  justify-content: center;
  height: auto;
  margin-left: 15px;
}
.button-container-social {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.col.el-col.el-col-24 {
  width: 100%;
}
.el-step__head.is-success {
    color: #6a41bdca;
    border-color: #6a41bdca;
}
.el-step__title.is-success {
    color: #6a41bdca;
}
.el-step__description.is-success {
    color: #6a41bdca;
}
.fotter-section {
  margin-top: 30px;
  width: 100%;
  height: 6px;
  border-radius: 20px;
  background-color: #6a41bdca;
}
</style>

<style lang="scss">
@import './styles/style.scss';
</style>
<style lang="scss" scoped>
@import './styles/style-scoped.scss';
</style>
